import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sparkles, ShieldCheck } from "lucide-react";
import { AI_TOOLS_PREVIEW } from "../portalPreviewData";

export default function ComplianceAIToolsPreview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold text-foreground">Compliance Center — AI Tools</h2>
        <p className="text-sm text-muted-foreground">
          Every draft below routes to a human reviewer before anything is final — AI-initiated, human-authorized.
        </p>
      </div>

      <div className="flex items-start gap-2.5 p-3 rounded-lg border border-secondary/30 bg-secondary/5 text-sm text-foreground">
        <ShieldCheck className="w-4 h-4 mt-0.5 text-secondary shrink-0" />
        <p>Nothing here executes automatically. AI proposes, a human confirms — every time.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {AI_TOOLS_PREVIEW.map((t) => (
          <Card key={t.id}>
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between gap-2">
                <CardTitle className="text-sm flex items-center gap-1.5">
                  <Sparkles className="w-3.5 h-3.5 text-secondary" />
                  {t.name}
                </CardTitle>
                <Badge variant="outline" className="text-[10px]">{t.metric}</Badge>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground leading-relaxed">{t.desc}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
